import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Download } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center bg-[#FAF8F5] px-4 pt-20 pb-16 overflow-hidden" data-id="element-44">
      {/* Abstract Background Element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#E8B4B8]/10 rounded-bl-[100px] -z-10" data-id="element-45" />

      <div className="max-w-4xl mx-auto text-center z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider uppercase bg-[#D4735E]/10 text-[#D4735E] rounded-full" data-id="element-48">
            Para mujeres cansadas de relaciones tóxicas (25–45 años)
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-serif font-bold text-[#2D2D2D] leading-tight mb-6" data-id="element-49">
          Plan NoMásTóxicos™
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-[#666666] mb-8 font-serif italic max-w-2xl mx-auto" data-id="element-50">
          Cómo dejar de atraer hombres que te usan y empezar a atraer hombres
          que te eligen en 30 días.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-xl shadow-[#D4735E]/5 mb-10 max-w-2xl mx-auto border border-[#D4735E]/10" data-id="element-51">
          <p className="text-lg md:text-xl text-[#2D2D2D] font-medium" data-id="element-52">
            Si siempre eliges hombres que no te eligen, no es mala suerte:{' '}
            <span className="text-[#D4735E] font-bold" data-id="element-53">
              es tu sistema de selección.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-54">
          <Button href="https://glowliftessencemx.com/checkouts/cn/hWN7pNUOqpeQk0A6TRAI7fAA/es-us?_r=AQABXEotWrlYvHcXS4HsY7ztujjlFOkA_CFfDQ7gJylr8qE&preview_theme_id=184489181460&skip_shop_pay=true" withIcon className="w-full md:w-auto text-lg px-10" data-id="element-55">
            Descargar Plan – $14.99
          </Button>

          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6 text-sm text-[#666666] mt-4" data-id="element-56">
            <span className="flex items-center gap-1.5" data-id="element-57">
              <Download className="w-4 h-4 text-[#D4735E]" data-id="element-58" />
              Acceso inmediato en PDF
            </span>
            <span className="hidden md:inline text-[#D4735E]" data-id="element-59">•</span>
            <span className="flex items-center gap-1.5" data-id="element-60">
              <ShieldCheck className="w-4 h-4 text-[#D4735E]" data-id="element-61" />
              Pago único y seguro
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}